import React, { useContext } from "react";
import { string, func, oneOf } from "prop-types";
import { useTextDomainContext } from "@/app/providers";
import { AutocompleteDropdown, FabekeDropdown, SimpleDropdown } from "./";

export const DateUnitDropDown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const options = [
    {
      value: "month",
      label: gettext("Month"),
    },
    {
      value: "year",
      label: gettext("Year"),
    },
  ];
  const propsDefault = {
    componentLabel: gettext("Unit"),
  };

  // Use props directly with fallback instead of state
  const componentLabel = props.componentLabel || propsDefault.componentLabel;

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          size="small"
          sx={{
            width: 110,
          }}
        />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
        />
      )}

      {props.visualStyle === "old" && (
        <FabekeDropdown
          options={
            options as unknown as import("@/types/Dropdown.types").DropdownOption[]
          }
          componentLabel={componentLabel}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          size="small"
        />
      )}
    </>
  );
};

DateUnitDropDown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  onChange: func,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
};
